import styled, { StyledComponent } from 'styled-components';
import { Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .emp-ant-drawer-body {
    padding: 0 24px;
  }

  // Table
  .emp-ant-table-wrapper {
    .emp-ant-table-thead > tr > th,
    .emp-ant-table-thead > tr > td {
      border-top: 1px solid #c9c9c9;
      border-bottom: 1px solid #c9c9c9;
      background: #f6f6f6;
      vertical-align: top;
    }
    .emp-ant-table .emp-ant-table-header {
      border-radius: 0;
    }
    .emp-ant-table-container table > thead > tr:first-child {
      th:first-child {
        border-start-start-radius: 0;
      }
      & > *:first-child {
        border-start-start-radius: 0;
      }
      & > *:last-child {
        border-start-end-radius: 0;
      }
    }
    tr.emp-ant-table-expanded-row > td {
      background: transparent;
    }
    .emp-ant-table.emp-ant-table-middle .emp-ant-table-tbody > .emp-ant-table-expanded-row > td {
      padding: 8px 45px;
    }
  }
`;

export const StyledHeader: StyledComponent<'div', any> = styled.div`
  color: #333;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto, sans-serif;
  line-height: 24px;
  margin-right: 28px;
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;

export const StyledDiffDisplayCardWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledDiffDisplayCard: StyledComponent<'div', any> = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const StyledArrow: StyledComponent<'span', any> = styled.span`
  padding: 4px 8px;
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
`;

export const StyledTitleText: StyledComponent<'span', any> = styled.span`
  padding: 4px 8px;
  flex-shrink: 0;
  align-self: flex-start;
`;

export const StyledRelatedNameText: StyledComponent<'span', any> = styled.span`
  color: #1f1f1f;
  font-weight: 500;
  background: #f0f0f0;
  padding: 3px 4px;
`;

export const StyledUpdateText: StyledComponent<'span', any> = styled.span`
  padding: 3px 4px;
  border-radius: 2px;
  border: 1px solid #52c41a;
  color: #52c41a;
  font-weight: 500;
`;

export const StyledNoChangeText: StyledComponent<'span', any> = styled.span`
  padding: 3px 4px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
  color: #bfbfbf;
  font-weight: 500;
`;

export const StyledOriginNameText: StyledComponent<'span', any> = styled.span`
  background: #fff1f0;
  padding: 4px 8px;
  text-decoration: line-through;
  word-break: break-all;
`;

export const StyledCurrentNameText: StyledComponent<'span', any> = styled.span`
  background: #f6ffed;
  padding: 4px 8px;
  text-decoration: underline;
  word-break: break-all;
`;

export const StyledSuccessText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #52c41a;
  margin-bottom: 16px;
`;

export const StyledTextBtn: StyledComponent<'div', any> = styled.div`
  color: #0046ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 32px;
  gap: 4px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
`;
